import { useEffect } from 'react';

import { isMockMedplumMode } from '../../../lib/isMockMedplumMode';
import { hasProviderDecisionOnAppointmentFlowMessage } from '../../messaging/appointmentRequestMessage';
import { useMessagingRealtimeOptional } from '../../messaging/hooks/useMessagingRealtime';

/**
 * Refetch portal data when a provider accept/decline is patched onto an appointment-flow
 * message. Complements FhirRealtime Task/Appointment subscriptions when cross-actor WS
 * delivery is delayed or missed.
 */
export function usePortalAppointmentFlowMessageRefresh(refresh: () => void): void {
  const messaging = useMessagingRealtimeOptional();

  useEffect(() => {
    if (isMockMedplumMode() || !messaging) return;
    return messaging.onMessage((comm) => {
      if (hasProviderDecisionOnAppointmentFlowMessage(comm)) {
        refresh();
      }
    });
  }, [messaging, refresh]);
}
